// extracted by mini-css-extract-plugin
export var HeroWrapper = "Hero-module--HeroWrapper--2PfRg";
export var animated_background = "Hero-module--animated_background--1xW4Z";
export var ImageWrapper = "Hero-module--ImageWrapper--14a-F";
export var GatsbyImageWrapper = "Hero-module--GatsbyImageWrapper--2jvRw";